import { cx } from "../utils/cx";
import styles from "./Tabs.module.css";

export interface TabItem {
  id: string;
  label: string;
}

interface TabsProps {
  items: TabItem[];
  activeId: string;
  onChange: (id: string) => void;
}

/**
 * Horizontal tab navigation with an accent underline on the active tab
 * (style-guide.md: Tabs). Controlled — the parent owns `activeId`.
 */
function Tabs({ items, activeId, onChange }: TabsProps) {
  return (
    <div className={styles.tabList} role="tablist">
      {items.map((item) => {
        const active = item.id === activeId;
        return (
          <button
            key={item.id}
            type="button"
            role="tab"
            aria-selected={active}
            className={cx(styles.tab, active && styles.active)}
            onClick={() => onChange(item.id)}
          >
            {item.label}
          </button>
        );
      })}
    </div>
  );
}

export default Tabs;
